module.exports = __webpack_public_path__ + "media/images/games/35reveal/zebra-8c7fdfeeea421a1e86a6470c8573aaa9.png";